/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountLoginAs
 */
export interface AccountLoginAs {
    /**
     * 
     * @type {string}
     * @memberof AccountLoginAs
     */
    email: string;
}

export function AccountLoginAsFromJSON(json: any): AccountLoginAs {
    return {
        'email': json['email'],
    };
}

export function AccountLoginAsToJSON(value?: AccountLoginAs): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'email': value.email,
    };
}


